import { withTokensIfNeeded } from 'common/api/utils/withTokensIfNeeded';
import { FEATURE_FLAGS_URL } from 'common/api/config';

export type ApiResponseFeatureFlags = {
    legacyFamilyId?: number | null;
    featureFlags: Array<{
        key: string;
        enabled: boolean;
    }>;
};

const FEATURE_FLAG_LEGACY_FAMILY_RETRY_DELAYS_MS = [500, 1000, 2000, 4000];

const wait = (delay: number) => new Promise((resolve) => setTimeout(resolve, delay));

const getCrmFeatureFlagsOnce = async () => {
    return await withTokensIfNeeded<ApiResponseFeatureFlags>(`${FEATURE_FLAGS_URL}?api-version=1`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    });
};

const shouldRetryFeatureFlags = (result: Awaited<ReturnType<typeof getCrmFeatureFlagsOnce>>) => {
    if (!result.response?.ok || !result.data) {
        return false;
    }

    return result.data.legacyFamilyId == null;
};

export const getCrmFeatureFlags = async () => {
    let result = await getCrmFeatureFlagsOnce();

    for (const delay of FEATURE_FLAG_LEGACY_FAMILY_RETRY_DELAYS_MS) {
        if (!shouldRetryFeatureFlags(result)) {
            return result;
        }

        await wait(delay);
        result = await getCrmFeatureFlagsOnce();
    }

    return result;
};
